// 4 điểm đến nhóm đã thực địa — nội dung lấy từ Script.docx.
// image: để trống thì thẻ hiển thị ô màu + biểu tượng; thêm ảnh thật bằng cách gán đường dẫn, ví dụ image: '/tan-chau.jpg' (đặt file trong /public).
export const stories = [
  {
    "slug": "lang-to-lua-tan-chau",
    "title": "Ghé Tân Châu: Nghe tiếng thoi dệt & chuyện Lãnh Mỹ A bên dòng sông Tiền",
    "place": "Thị xã Tân Châu, An Giang",
    "excerpt": "Về Tân Châu ghé thăm xưởng dệt gia đình bên dòng sông Tiền, nghe tiếng thoi lạch cạch và \"un-lock\" bí thuật nhuộm trái mặc nưa tạo nên Lãnh Mỹ A - loại lụa tự nhiên trứ danh với khả năng thích ứng thời tiết linh hoạt cùng vẻ đẹp sang trọng vượt thời gian.!",
    "body": [
      {
        "type": "p",
        "text": "Về An Giang, tụi mình tìm đến tận một hộ dân làm nghề dệt lụa lâu đời nằm êm đềm bên dòng sông Tiền ở thị xã Tân Châu. Vừa bước qua khoảng sân phơi nắng rực rỡ ngập tràn những sào lụa đen tuyền bóng mượt, tiếng khung dệt lạch cạch... lạch cạch... đã vang vọng khắp gian nhà."
      },
      {
        "type": "h",
        "text": "1. Ký ức về một \"xứ tằm tang\" hoàng kim"
      },
      {
        "type": "p",
        "text": "Ngồi bên tách trà ấm cùng chú chủ xưởng dệt lâu năm, chú kể rằng nghề trồng dâu nuôi tằm ở Tân Châu bắt đầu phát triển rực rỡ từ đầu thế kỷ XX nhờ dải đất phù sa ven sông Tiền vô cùng màu mỡ."
      },
      {
        "type": "ul",
        "items": [
          [
            "Giai đoạn 1920 - 1945",
            "Tân Châu nhanh chóng trở thành thủ phủ tơ lụa sầm uất và nổi tiếng nhất vùng Nam Bộ."
          ],
          [
            "Vươn xa quốc tế",
            "Sản phẩm lụa Tân Châu khi ấy không chỉ phục vụ cho giới thượng lưu, quý tộc Nam Kỳ mà còn theo các thương lái xuất khẩu sang Campuchia, Lào, Thái Lan, Philippines và thậm chí vươn xa sang thị trường Châu Âu."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Bí thuật tạo nên tuyệt tác Lãnh Mỹ A"
      },
      {
        "type": "p",
        "text": "Sở dĩ Lãnh Mỹ A được mệnh danh là \"nữ hoàng của các loại tơ tằm\" là nhờ quy trình chế tác hoàn toàn thủ công vô cùng kỳ công mà không máy móc hiện đại nào thay thế được:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Kỹ thuật dệt Satin 8",
            "Tơ tằm tự nhiên được chọn lọc kỹ càng và dệt theo kỹ thuật Satin 8 (kỹ thuật dệt satin khó nhất) để tạo độ dai, mịn và bề mặt óng ả."
          ],
          [
            "Nhuộm nhựa trái mặc nưa",
            "Bí quyết cốt lõi nằm ở quả mặc nưa. Nhựa trái mặc nưa khi giã nát có màu xanh mộc mạc, nhưng khi ngấm sâu vào sợi tơ và tiếp xúc với nắng gió sông Tiền sẽ tự oxy hóa chuyển thành màu đen tuyền bóng bẩy."
          ],
          [
            "100 lần nhuộm - phơi kiên trì",
            "Tấm lụa phải trải qua hơn 100 lần giặt, đập, nhuộm nhựa và phơi nắng liên tục trong gần 4 tháng ròng."
          ],
          [
            "Đặc tính độc bản",
            "Lãnh Mỹ A có khả năng \"mát rượi vào mùa hè, ấm áp vào mùa đông\". Đặc biệt, lụa không phai màu mà càng giặt lại càng mềm mại, óng ả theo thời gian."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Ngọn lửa giữ nghề trong gian nhà nhỏ"
      },
      {
        "type": "p",
        "text": "Thập niên 1970, sự xuất hiện của sợi tổng hợp và vải nylon giá rẻ tràn ngập thị trường khiến làng nghề suy giảm mạnh. Tuy nhiên, nhờ tâm huyết của những nghệ nhân kỳ cựu (như gia đình cố nghệ nhân Tám Lăng), ngọn lửa dệt lụa truyền thống vẫn được kiên trì giữ qua bao thăng trầm."
      },
      {
        "type": "p",
        "text": "Ngày nay, ghé thăm nhà dân Tân Châu, bạn sẽ nhận ra bước chuyển mình đầy sức sống của thế hệ tiếp nối:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Mở rộng bảng màu thiên nhiên",
            "Ngoài màu đen mặc nưa truyền thống, người thợ đã nghiên cứu nhuộm thêm nhiều màu sắc tự nhiên từ vỏ cây, củ quả (đỏ bóc-đô, vàng đồng, xám, hồng cánh sen...)."
          ],
          [
            "Vươn tầm thời trang quốc tế",
            "Lãnh Mỹ A trở thành chất liệu cao cấp đồng hành cùng các NTK tên tuổi Việt Nam (như Võ Việt Chung, Công Trí) xuất hiện kiêu hãnh trên các sàn diễn lớn như New York Fashion Week và tạp chí Vogue."
          ],
          [
            "Du lịch trải nghiệm",
            "Các xưởng dệt gia đình mở cửa đón du khách ghé thăm, tận mắt chứng kiến quy trình ươm tơ, dệt vải và tự tay thử nhuộm lụa bằng trái mặc nưa."
          ]
        ]
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Chạm tay vào tấm Lãnh Mỹ A mát rượi ngay tại xưởng dệt gia đình, mới thấy trân trọng từng giọt mồ hôi và tài hoa của người thợ Tân Châu. Đây không chỉ là một sản phẩm may mặc, mà là cả một di sản văn hóa sống động vẫn đang chảy tràn sức sống bên dòng sông Tiền."
      }
    ],
    "refs": [
      [
        "Báo Lao Động",
        "Lãnh Mỹ A - tơ lụa quý tộc một thời",
        "laodong.vn"
      ],
      [
        "Đài Tiếng nói Việt Nam (VOV)",
        "Lụa Lãnh Mỹ A - Hồn đất An Giang",
        "vov.vn"
      ],
      [
        "Ủy ban Nhà nước về người Việt Nam ở nước ngoài (SCOV - Bộ Ngoại giao)",
        "Thăm làng dệt lụa Tân Châu - An Giang",
        "scov.gov.vn"
      ],
      [
        "Cổng thông tin Điện tử tỉnh An Giang",
        "Làng nghề dệt tơ lụa Tân Châu",
        "angiang.gov.vn"
      ],
      [
        "Cục Du lịch Quốc gia Việt Nam",
        "Gìn giữ di sản lụa Tân Châu An Giang",
        "vietnamtourism.gov.vn"
      ]
    ],
    "read": "3 phút đọc",
    "province": "An Giang",
    "icon": "checkroom",
    "date": "28/09/2026",
    "short": "Lụa Lãnh Mỹ A",
    "category": "Câu chuyện",
    "image": "/ToLua.png",
    "featured": true,
    "order": 1
  },
  {
    "slug": "tho-cam-cham-chau-phong",
    "title": "Ghé Châu Phong: Tiếng thoi dệt thổ cẩm trong ngôi nhà sàn người Chăm",
    "place": "Xã Châu Phong, Thị xã Tân Châu, An Giang",
    "excerpt": "Băng qua sông Hậu ghé thăm nhà sàn người Chăm ở Châu Phong, nghe tiếng thoi dệt lạch cạch và khám phá bí thuật nhuộm màu tự nhiên tạo nên những tấm thổ cẩm rực rỡ nét đẹp di sản Nam Bộ!",
    "body": [
      {
        "type": "p",
        "text": "Băng qua lòng sông Hậu rộng lớn, tụi mình tìm về xã Châu Phong (thị xã Tân Châu, An Giang) và dừng chân trước một ngôi nhà sàn gỗ cổ kính của gia đình cô Chăm. Trong không gian yên bình rợp bóng mát, tiếng dập khung dệt lạch cạch... lạch cạch... ngân vang rộn rã từng nhịp nhịp nhàng."
      },
      {
        "type": "h",
        "text": "1. Nét đẹp văn hóa lâu đời của cộng đồng Chăm"
      },
      {
        "type": "p",
        "text": "Bên khung dệt gỗ cổ truyền, cô Chăm mỉm cười chào khách rồi tỉ tê kể về nguồn gốc nghề dệt thổ cẩm của đồng bào mình bên dòng sông Hậu:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Gắn liền với đời sống",
            "Nghề dệt thổ cẩm hình thành cùng quá trình định cư của người Chăm An Giang, truyền từ mẹ sang con qua biết bao thế hệ phụ nữ trong gia đình."
          ],
          [
            "Biểu tượng trang phục",
            "Từng chiếc xà rông, khăn mêu (khăn đội đầu), áo thổ cẩm dệt ra không chỉ để mặc hằng ngày mà còn là trang phục trang trọng không thể thiếu trong các dịp lễ hội lớn như lễ Ramadan, lễ Raya..."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Kỹ thuật dệt thủ công với hoa văn tinh xảo"
      },
      {
        "type": "p",
        "text": "Mỗi sản phẩm thổ cẩm Châu Phong là một tác phẩm nghệ thuật đòi hỏi sự kiên nhẫn, đôi mắt thẩm mỹ và sự khéo léo tối đa của người thợ:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Nhuộm màu tự nhiên",
            "Sợi chỉ được nhuộm từ nguyên liệu thiên nhiên như vỏ cây, mủ cây, củ mặc nưa... tạo ra các gam màu sống động, bền đẹp như đỏ bóc-đô, vàng nghệ, xanh lá, xám đen."
          ],
          [
            "Kỹ thuật dệt thủ công tỉ mỉ",
            "Người thợ dùng đôi chân nhịp nhàng đạp bàn dập, đôi tay uyển chuyển đưa thoi luồn từng sợi chỉ màu qua lại."
          ],
          [
            "Hoa văn độc đáo",
            "Các họa tiết hình học, ô vuông, đường zigzag, bông hoa... được tính toán chính xác trực tiếp trong đầu và thể hiện nhịp nhàng trên khung dệt mà không cần bất kỳ bản vẽ sẵn nào."
          ],
          [
            "Sản phẩm phong phú",
            "Bên cạnh xà rông, khăn mêu truyền thống, làng nghề còn dệt nên túi xách, bóp viền, nón, khăn quàng cổ phục vụ đời sống hiện đại."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Lan tỏa sức sống thổ cẩm Châu Phong"
      },
      {
        "type": "p",
        "text": "Ngày nay, làng dệt thổ cẩm Châu Phong không chỉ giữ gìn truyền thống mà còn trở thành điểm sáng du lịch văn hóa thu hút du khách trong và ngoài nước:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Mô hình Hợp tác xã",
            "Các hộ dân liên kết sản xuất, chuẩn hóa chất lượng để đưa sản phẩm thổ cẩm Châu Phong đến với các thị trường du lịch lớn."
          ],
          [
            "Trải nghiệm văn hóa bản địa",
            "Du khách ghé thăm được bước lên nhà sàn gỗ, tìm hiểu phong tục tập quán, khoác thử trang phục truyền thống Chăm và tự tay thử đưa thoi dệt vải trên khung gỗ."
          ]
        ]
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Ghé thăm ngôi nhà sàn Châu Phong, ngắm nhìn những tấm thổ cẩm rực rỡ sắc màu dưới ánh nắng chiều sông Hậu, tụi mình cảm nhận sâu sắc bản sắc văn hóa độc đáo và tình yêu di sản tha thiết của đồng bào Chăm An Giang."
      }
    ],
    "refs": [
      [
        "Cổng thông tin Điện tử tỉnh An Giang",
        "Độc đáo nghề dệt thổ cẩm Chăm Châu Phong",
        "angiang.gov.vn"
      ],
      [
        "Báo Dân tộc và Phát triển (Uỷ ban Dân tộc)",
        "Giữ lửa nghề dệt thổ cẩm Chăm ở Châu Phong",
        "baodantoc.vn"
      ],
      [
        "Đài Tiếng nói Việt Nam (VOV)",
        "Thổ cẩm Châu Phong - Sức hút nét văn hóa Chăm An Giang",
        "vov.vn"
      ],
      [
        "Báo Lao Động",
        "Sức sống làng dệt thổ cẩm Chăm Châu Phong",
        "laodong.vn"
      ],
      [
        "Cục Du lịch Quốc gia Việt Nam",
        "Khám phá làng dệt thổ cẩm Chăm Châu Phong, An Giang",
        "vietnamtourism.gov.vn"
      ]
    ],
    "read": "2 phút đọc",
    "province": "An Giang",
    "icon": "texture",
    "date": null,
    "short": "Thổ cẩm Chăm",
    "category": "Câu chuyện",
    "image": "/DetThoCam.png",
    "order": 2
  },
  {
    "slug": "lo-gach-mang-thit",
    "title": "Ghé Mang Thít: Ngơ ngác trước \"vương quốc lò gạch\" bên dòng Cổ Chiên",
    "place": "Huyện Mang Thít, Tỉnh Vĩnh Long",
    "excerpt": "Xuôi dòng Cổ Chiên ghé xưởng gạch ven kênh Thầy Đức, ngắm hàng trăm lò vòm đỏ thắm mọc lên như tháp cổ và cảm nhận sức sống của \"Vương quốc gốm đỏ\" Mang Thít!",
    "body": [
      {
        "type": "p",
        "text": "Theo dòng sông Cổ Chiên xuôi về huyện Mang Thít (Vĩnh Long), tụi mình ghé vào xưởng làm gạch lâu đời của gia đình chú Bảy nằm ven kênh Thầy Đức. Từ xa nhìn lại, hàng trăm lò gạch gốm hình vòm đỏ thắm mọc lên san sát nhau trông như những ngọn tháp cổ kính tuyệt đẹp nổi bật trên nền trời miền Tây."
      },
      {
        "type": "h",
        "text": "1. Ký ức về di sản công nghiệp sông nước"
      },
      {
        "type": "p",
        "text": "Rót chén trà xanh mời khách, chú Bảy hồi tưởng lại thời kỳ hoàng kim của vùng đất được mệnh danh là \"Vương quốc lò gạch\":"
      },
      {
        "type": "ul",
        "items": [
          [
            "Lịch sử hàng trăm năm",
            "Nghề làm gạch gốm Mang Thít hình thành và phát triển từ đầu thế kỷ XX nhờ dải đất sét đỏ phù sa ven sông Cổ Chiên dồi dào, màu mỡ."
          ],
          [
            "Thời kỳ rực rỡ",
            "Những năm 1980 - 1990, nơi đây có đến hàng ngàn lò gạch hoạt động rực lửa ngày đêm. Gạch gốm theo tàu thủy xuôi dòng ra biển lớn xuất khẩu đi khắp châu Âu, châu Mỹ và các nước Đông Nam Á."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Kỳ công nhào nặn đất phù sa thành gốm đỏ"
      },
      {
        "type": "p",
        "text": "Để tạo nên những viên gạch, sản phẩm gốm đỏ độc đáo trứ danh Mang Thít, người thợ phải trải qua những công đoạn vất vả, công phu:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Khai thác & nhồi đất",
            "Đất sét đỏ phù sa được lọc kỹ, nhồi thật dẻo mịn trước khi đưa vào khuôn tạo hình."
          ],
          [
            "Chất lò & đốt lửa",
            "Gạch sống sau khi phơi khô được xếp cẩn thận vào bên trong lò hình vòm. Người thợ dùng trấu đốt lửa liên tục suốt nhiều ngày đêm để nung chín."
          ],
          [
            "Sắc đỏ tự nhiên",
            "Nhờ đặc tính của đất sét sông Cổ Chiên và kỹ thuật canh lửa tài hoa, gạch gốm ra lò có màu đỏ cam tự nhiên, lên nước bóng mịn mà không cần qua bất kỳ khâu nhuộm màu nào."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Bước chuyển mình thành Di sản tương lai"
      },
      {
        "type": "p",
        "text": "Dù nhịp sản xuất công nghiệp hiện đại khiến nhiều lò gạch nung trấu truyền thống ngưng hoạt động, Mang Thít đang đứng trước bước ngoặt di sản đầy tự hào:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Đề án \"Di sản tương lai Mang Thít\"",
            "Tỉnh Vĩnh Long quy hoạch bảo tồn vùng lò gạch cổ thành không gian di sản công nghiệp và kiến trúc độc đáo bậc nhất ĐBSCL."
          ],
          [
            "Điểm check-in & nghệ thuật",
            "Những lò gạch hình vòm rêu phong trở thành nguồn cảm hứng nghệ thuật, thu hút đông đảo du khách và nhiếp ảnh gia tìm đến thưởng lãm, ghi lại những thước phim đắt giá."
          ]
        ]
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Bước chân giữa những vòm lò gạch rêu phong nhuốm màu thời gian, chạm tay vào chất gốm đỏ ấm áp, mới cảm nhận trọn vẹn sức sống kiên cường và nét đẹp độc bản của di sản Mang Thít bên dòng Cổ Chiên."
      }
    ],
    "refs": [
      [
        "Báo Điện tử Chính phủ",
        "Bảo tồn di sản đương đại Mang Thít Vĩnh Long",
        "baochinhphu.vn"
      ],
      [
        "Cổng thông tin Điện tử tỉnh Vĩnh Long",
        "Làng nghề gạch gốm Mang Thít",
        "vinhlong.gov.vn"
      ],
      [
        "Đài Tiếng nói Việt Nam (VOV)",
        "Vương quốc lò gạch Mang Thít - Di sản độc đáo Nam Bộ",
        "vov.vn"
      ],
      [
        "Báo Lao Động",
        "Hồn gốm đỏ Mang Thít bên dòng Cổ Chiên",
        "laodong.vn"
      ],
      [
        "Cục Du lịch Quốc gia Việt Nam",
        "Khám phá Vương quốc gốm đỏ Mang Thít, Vĩnh Long",
        "vietnamtourism.gov.vn"
      ]
    ],
    "read": "2 phút đọc",
    "province": "Vĩnh Long",
    "icon": "account_balance",
    "date": null,
    "short": "Gốm đỏ Mang Thít",
    "category": "Câu chuyện",
    "image": "/Gach.png",
    "order": 3
  },
  {
    "slug": "banh-trang-cu-lao-may",
    "title": "Ghé Cù lao Mây: Dạo bếp tráng bánh & thưởng thức vị ngọt hơn bách niên",
    "place": "Cù lao Mây (Xã Phú Thành, Huyện Trà Ôn, Tỉnh Vĩnh Long)",
    "excerpt": "Qua chuyến phà ngang ghé thăm căn bếp nhỏ cù lao Mây, xem các cô các chị thoăn thoắt tráng từng chiếc bánh dẻo thơm và \"thưởng thức\" hương vị ngọt ngào hơn 100 năm tuổi!",
    "body": [
      {
        "type": "p",
        "text": "Về Vĩnh Long, tụi mình đón chuyến phà ngang bồng bềnh sang đất cù lao Mây (xã Phú Thành, huyện Trà Ôn). Vừa rẽ vào con hẻm nhỏ rợp bóng cây xanh bưởi mận, mùi thơm lừng của nếp chín quyện với nước cốt dừa béo ngậy từ căn bếp nhà các cô, các chị đã nhanh chóng níu chân tụi mình lại."
      },
      {
        "type": "h",
        "text": "1. Ký ức về làng nghề tráng bánh trăm năm"
      },
      {
        "type": "p",
        "text": "Bên bếp lửa bập bùng ấm áp, cô chủ nhà vừa đổ bột lên khuôn vải tráng vừa cười kể, nghề làm bánh tráng ở cù lao Mây đã gắn liền với bao thế hệ nơi đây suốt hơn một thế kỷ qua:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Nguồn gốc lâu đời",
            "Ban đầu xuất phát từ thói quen tự tráng bánh để thưởng thức và đãi khách mỗi dịp Lễ, Tết hay cúng giỗ của cư dân dải cù lao ven sông Hậu."
          ],
          [
            "Giao thương rộn rã",
            "Nhờ chất lượng thơm ngon vượt trội, bánh tráng cù lao Mây theo ghe bầu xuôi dòng sông Hậu tỏa đi khắp các tỉnh miền Tây và theo chân người con xa xứ đi khắp nơi."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Bí quyết tạo nên từng chiếc bánh dẻo thơm"
      },
      {
        "type": "p",
        "text": "Để có được tấm bánh tráng mỏng dẻo, thơm lừng đặc trưng, người dân cù lao phải tỉ mỉ chăm chút từng công đoạn hoàn toàn thủ công:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Chọn gạo & xay bột",
            "Phải chọn loại gạo nếp ngon, ngâm đủ giờ rồi xay nhuyễn, pha thêm nước cốt dừa béo ngậy và chút gia vị nêm nếm vừa vặn."
          ],
          [
            "Kỹ thuật tráng bánh",
            "Bàn tay người thợ thoăn thoắt xoay gáo bột đều tắp trên nồi hơi ngút khói, tráng bánh mỏng như giấy mà không hề bị rách."
          ],
          [
            "Phơi nắng vạt dừa",
            "Bánh tráng xong được nhấc cẩn thận lên chiếc vạt (vỉ) dừa đem phơi nắng tự nhiên. Nắng cù lao vừa đủ làm bánh khô lại nhưng vẫn giữ trọn độ dẻo dai."
          ],
          [
            "Đa dạng hương vị",
            "Ngoài bánh tráng nem truyền thống, làng nghề còn biến tấu thêm bánh tráng ngọt, bánh tráng nướng, bánh tráng ớt, bánh tráng sữa... đậm đà khẩu vị Nam Bộ."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Giữ lửa làng nghề nơi đất cù lao"
      },
      {
        "type": "p",
        "text": "Dù hiện nay máy móc công nghiệp rất phổ biến, nhiều hộ dân cù lao Mây vẫn kiên trì giữ phương pháp làm thủ công để bảo tồn nguyên vẹn hương vị truyền thống:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Hợp tác xã làng nghề",
            "Nhiều hộ gia đình đã liên kết lại thành Làng nghề Bánh tráng Cù lao Mây để hỗ trợ nhau đảm bảo chất lượng và đầu ra ổn định."
          ],
          [
            "Trải nghiệm du lịch",
            "Khách ghé thăm được tự tay thử tráng bánh trên nồi hơi, học cách nhấc bánh lên vạt dừa và thưởng thức chiếc bánh nướng nóng hổi ngay tại bếp."
          ]
        ]
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Thưởng thức một miếng bánh tráng dẻo thơm ngay tại căn bếp nhỏ cù lao Mây, mới cảm nhận trọn vẹn sự ngọt ngào của dải đất phù sa và tấm lòng hào sảng, hiếu khách của người dân Vĩnh Long."
      }
    ],
    "refs": [
      [
        "Báo Điện tử Chính phủ",
        "Làng nghề bánh tráng Cù lao Mây Vĩnh Long",
        "baochinhphu.vn"
      ],
      [
        "Cổng thông tin Điện tử tỉnh Vĩnh Long",
        "Làng nghề truyền thống Bánh tráng Cù Lao Mây",
        "vinhlong.gov.vn"
      ],
      [
        "Báo Lao Động",
        "Đậm đà hương vị bánh tráng Cù lao Mây",
        "laodong.vn"
      ],
      [
        "Đài Phát thanh và Truyền hình Vĩnh Long (THVL)",
        "Độc đáo bánh tráng Cù lao Mây",
        "thvl.vn"
      ],
      [
        "Cục Du lịch Quốc gia Việt Nam",
        "Khám phá du lịch làng nghề Bánh tráng Cù lao Mây",
        "vietnamtourism.gov.vn"
      ]
    ],
    "read": "2 phút đọc",
    "province": "Vĩnh Long",
    "icon": "bakery_dining",
    "date": null,
    "short": "Bánh tráng Cù lao Mây",
    "category": "Câu chuyện",
    "image": "/BanhTrang.png",
    "order": 4
  },
];
export const categories = ['Tất cả', ...new Set(stories.map(s => s.province))];
